import React, {useEffect, useRef, useState} from "react";
import styles from "./SalonCoverModal.module.scss";
import CropImageComponent from "../../../Common/CropImageComponent";
import UploadFileModal from "../../../Common/UploadFileModal";
import {Button} from "@mui/material";
import clx from "classnames";
import {authActions} from "../../store";
import {useDispatch} from "react-redux";
import { useTranslation } from 'react-i18next';

const SalonCoverModal = ({callback, closeModal, isEditForm}) => {
  const dispatch = useDispatch();
  const [imgValue, setImageValue] = useState('');
  const [fullImg, setFullImg] = useState('')
  const childRef = useRef();
  const { t } = useTranslation();
  
  useEffect(() => {
    if (imgValue) {
      if (isEditForm) {
        callback(imgValue)
        dispatch(authActions.EDIT_SALON_COVER.REQUEST({
          imgBase64: imgValue,
        }, closeModal))
      } else {
        callback(imgValue)
        closeModal()
      }
    }
  }, [imgValue])

  return (
    <div className={styles.worker_avatar_modal_container}>
      <UploadFileModal isMultiple={false} setUploadFiles={setFullImg}/>
      <CropImageComponent
        setImageValue={setImageValue}
        url={fullImg.url}
        ref={childRef}
        circularCrop={false}
        aspect={16 / 9}
      />
      <div className={clx(styles.button_block, {[styles.confirm_active]: !!fullImg?.url})}>
        <Button
          onClick={closeModal}
          className={styles.return_button}>
          {t('common.actions.cancel')} &gt;
        </Button>
        <Button
          className={styles.confirm_button}
          onClick={() => childRef.current.setCroppedImage()}
          variant="contained"
        >
          {t('common.actions.save')}
        </Button>
      </div>
    </div>
  );
}

export default SalonCoverModal;